import "./DirectorsPage.scss";
import {
  ContentArea,
  DirectorsInfoCardBlock,
  GridPresetMainContent,
  GridPresetSidebar,
  GridRow,
  HideFor,
  HeroBasic,
  Link,
  OptimizelyEditProperty,
  ArrowRightIcon,
} from "/App.Components";
import { DirectorsPageProps } from "/Models/Generated/DirectorsPageProps";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentAreaItemMargin } from "/Components/Shared/ContentAreaItem/ContentAreaItem";
import { FocusedLinksBlockProps } from "/Models/Generated/FocusedLinksBlockProps";

const DirectorsPage = ({
  pageHero,
  mainBody,
  directors,
  directorsPropertyName,
  sidebar,
}: DirectorsPageProps) => {
  const hasMainBody =
    Boolean(mainBody?.propertyName) || ContentArea.HasContent(mainBody);

  const mobileNavigationItems = (sidebar?.items ?? []).filter(
    (item) =>
      item.name === "FocusedLinksBlock" &&
      (item.component as FocusedLinksBlockProps | undefined)
        ?.showAsMobileNavigation,
  );
  const mobileNavigationLinks = (
    <div className="directors-page-norad__mobile-navigation-links">
      {mobileNavigationItems.map((item) => {
        const focusedLinks = item.component as FocusedLinksBlockProps;
        const links = [
          ...(focusedLinks.links ?? []),
          ...(focusedLinks.specialLinks ?? []),
        ];

        return (
          <ul key={item.blockId}>
            {links.map((link, index) => (
              <li key={`${item.blockId}-${index}`}>
                <Link
                  {...link}
                  isExternal={false}
                  iconPlacement="before"
                  icon={ArrowRightIcon}
                  size="x-small"
                  fixedIcon
                />
              </li>
            ))}
          </ul>
        );
      })}
    </div>
  );

  return (
  <div className="directors-page-norad">
    {pageHero && <HeroBasic {...pageHero} />}
    {!hasMainBody && mobileNavigationItems.length > 0 && (
      <HideFor desktop desktopMedium desktopLargeUp>
        <div className="directors-page-norad__mobile-navigation-links--top">
          <GridRow>
            <GridPresetMainContent>{mobileNavigationLinks}</GridPresetMainContent>
          </GridRow>
        </div>
      </HideFor>
    )}
    <div
      className={`directors-page-norad__main-content${
        !hasMainBody && mobileNavigationItems.length > 0
          ? " directors-page-norad__main-content--after-mobile-navigation"
          : ""
      }`}
    >
      <GridRow>
        <GridPresetMainContent>
          <div className="directors-page-norad__content-stack">
            {hasMainBody && (
              <div className="directors-page-norad__main-body">
                <ContentArea
                  {...mainBody}
                  contentAreaType={ContentAreaType.HalfWidth}
                />
              </div>
            )}
            {hasMainBody && mobileNavigationItems.length > 0 && (
              <HideFor desktop desktopMedium desktopLargeUp>
                <div className="directors-page-norad__mobile-navigation-links--with-main-body">
                  {mobileNavigationLinks}
                </div>
              </HideFor>
            )}
            <OptimizelyEditProperty
              propertyName={directorsPropertyName}
              clientRender
            >
              {(directors?.length ?? 0) > 0 && (
                <div className="directors-page-norad__cards">
                  {directors.map((director, idx) => (
                    <DirectorsInfoCardBlock
                      {...director}
                      key={idx}
                    />
                  ))}
                </div>
              )}
            </OptimizelyEditProperty>
          </div>
        </GridPresetMainContent>
        {(sidebar?.propertyName || ContentArea.HasContent(sidebar)) && (
          <GridPresetSidebar>
            <aside className="directors-page-norad__sidebar">
              <ContentArea
                {...sidebar}
                contentAreaType={ContentAreaType.OneThird}
                margin={ContentAreaItemMargin.Sidebar}
              />
            </aside>
          </GridPresetSidebar>
        )}
      </GridRow>
    </div>
  </div>
  );
};

export default DirectorsPage;
